import { useInfiniteQuery } from '@tanstack/react-query';

import {
  formatInfiniteData,
  getNextPageParam,
} from 'components/helpers/reactQuery';

export function useInfiniteProjectsDashboardsNavigationOptionSearchesQuery({
  params = {},
  queryOptions,
}) {
  return useInfiniteQuery({
    queryKey: ['projectsDashboards', 'navigationOptions', params],
    queryFn: async ({ pageParam = 1 }) => {
      const response = await axios.post(
        '/projects_dashboards/navigation_option_searches',
        { navigation_option_search: { ...params, page: pageParam } },
      );

      return response.data;
    },
    getNextPageParam,
    select: (data) =>
      formatInfiniteData({ data, resourceTypes: ['folder', 'project'] }),
    ...queryOptions,
  });
}
